import Signup from '../../components/Signup';
const index = () => {
  return <Signup />;
};

export default index;
